import { useState } from "react";
import { ContractStep, DetailTotalData } from "src/api/contract/contract-types";
import { ArticleSection } from "src/components/layout/ArticleSection";
import ContractorAndOrganizationDetail from "./detailComponent/ContractorNOrganizationDetail";
import ContractorNOrganizationEdit from "./editComponent/ContractorNOrganizationEdit";

/**
 * 상품정보 영역
 * Props
 * detailData
 */
interface ContractBasicProp {
  detailData: DetailTotalData; //상품 상세 조회 정보
  setData: Function;
}

const ContractorAndOrganization = ({ detailData, setData }: ContractBasicProp) => {
  const [editable, setEditable] = useState(false);
  const [saveFlags, setSaveFlags] = useState(false);
  const [popupState, setPopupState] = useState(false);
  const [editConfrim, setEditConfrim] = useState(false);
  const [commonModals, setCommonModals] = useState<any>({
    message: "",
    title: "",
  });

  const contractStep = String(detailData?.contract?.contractStep);
  const productType = String(detailData?.product?.productType);
  // 공간임대(FULL_COURT)의 계약 관리자 정보는 해지완료/이용완료 상태에서도 편집 가능하도록 함
  // (비활성 목록에 없는 값을 넘겨 편집 버튼을 활성화. 비상주/공간예약은 현행 유지)
  const isEditableCompleteState =
    productType === "FULL_COURT" &&
    (contractStep === ContractStep.USE_COMPLETE || contractStep === ContractStep.TERMINATE_COMPLETE);
  const editButtonStep = isEditableCompleteState ? "" : contractStep;

  return (
    <ArticleSection
      title={"계약 관리자 정보"}
      isEditable={editable}
      setIsEditable={setEditable}
      onClickSave={() => setSaveFlags(true)}
      popupState={popupState}
      setPopupState={setPopupState}
      editConfrim={editConfrim}
      setEditConfrim={setEditConfrim}
      editConfrimTitle={"계약관리자를 변경하시겠습니까?"}
      editConfrimMessage={<p>현재 계약관리자가 해당 계약에 대해 앱에 등록한 결제카드는 초기화 됩니다.</p>}
      closeConfirmOnClick={true}
      commonModals={commonModals}
      disabledState={[editButtonStep, productType]}
      children={
        editable === false ? (
          <ContractorAndOrganizationDetail detailData={detailData} />
        ) : (
          <ContractorNOrganizationEdit
            detailData={detailData}
            setData={setData}
            setEditable={setEditable}
            saveFlags={saveFlags}
            setSaveFlags={setSaveFlags}
            popupState={popupState}
            setPopupState={setPopupState}
            setCommonModals={setCommonModals}
            setEditConfrim={setEditConfrim}
          />
        )
      }
    />
  );
};

export default ContractorAndOrganization;
